import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './styles/index.css'

/**
 * Crash-loop damper. On 2026-08-22 a real iPhone was killed by the on-device encoder and
 * Safari revived the tab every 2-4 seconds - each revival re-ran the thing that killed it.
 * JS state dies with the tab but sessionStorage survives it, so rapid successive loads are
 * detectable here: three loads inside 45 seconds is not a person, and flips the session into
 * safe mode (read by lib/segment.ts - the segmenter stays off, taps fall back to the server,
 * nothing else changes). Cleared automatically when the tab is closed, because that is what
 * sessionStorage is.
 */
try {
  const now = Date.now()
  const recent = (JSON.parse(sessionStorage.getItem('asb-load-times') ?? '[]') as number[]).filter(
    (t) => now - t < 45_000,
  )
  recent.push(now)
  sessionStorage.setItem('asb-load-times', JSON.stringify(recent))
  if (recent.length >= 3) sessionStorage.setItem('asb-safe-mode', '1')
} catch {
  // Storage can be unavailable (private mode quirks); the damper is best-effort.
}

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
